module.exports = __webpack_public_path__ + "assets/checkbox-unchecked.svg";